var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "color-manager uk-margin-remove-top uk-table uk-table-divider uk-table-justify"
  }, [_c('thead', [_c('th', [_vm._v(_vm._s(_vm.$t('fields.name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('fields.code')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('fields.slug')))]), _vm._v(" "), _c('th', {
    staticClass: "uk-table-shrink"
  })]), _vm._v(" "), _c('tbody', [_vm._l((_vm.colors), function(color, index) {
    return _c('tr', {
      key: color.code
    }, [_c('td', [_c('text-input', {
      ref: "colorName",
      refInFor: true,
      attrs: {
        "errors": _vm.errorsFor(index, 'name')
      },
      on: {
        "blur": function($event) {
          _vm.removeColorWhenEmpty(index)
        },
        "input": _vm.onInput
      },
      model: {
        value: (color.name),
        callback: function($$v) {
          color.name = $$v
        },
        expression: "color.name"
      }
    })], 1), _vm._v(" "), _c('td', [_c('color-code-input', {
      ref: "colorCode",
      refInFor: true,
      attrs: {
        "errors": _vm.errorsFor(index, 'code')
      },
      on: {
        "blur": function($event) {
          _vm.removeColorWhenEmpty(index)
        },
        "input": _vm.onInput
      },
      model: {
        value: (color.code),
        callback: function($$v) {
          color.code = $$v
        },
        expression: "color.code"
      }
    })], 1), _vm._v(" "), _c('td', [_c('text-input', {
      ref: "colorSlug",
      refInFor: true,
      attrs: {
        "errors": _vm.errorsFor(index, 'slug')
      },
      on: {
        "blur": function($event) {
          _vm.removeColorWhenEmpty(index)
        },
        "input": _vm.onInput
      },
      model: {
        value: (color.slug),
        callback: function($$v) {
          color.slug = $$v
        },
        expression: "color.slug"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "uk-table-shrink"
    }, [_c('common-button', {
      attrs: {
        "icon": "trash",
        "tabindex": "-1"
      },
      on: {
        "click": function($event) {
          _vm.maybeRemoveColor(index)
        }
      }
    })], 1)])
  }), _vm._v(" "), _c('tr', [_c('td', [_c('text-input', {
    ref: "newColorName",
    on: {
      "input": _vm.addEntryWithName
    },
    model: {
      value: (_vm.newEntry.name),
      callback: function($$v) {
        _vm.newEntry.name = $$v
      },
      expression: "newEntry.name"
    }
  })], 1), _vm._v(" "), _c('td', [_c('color-code-input', {
    on: {
      "input": _vm.addEntryWithCode
    },
    model: {
      value: (_vm.newEntry.code),
      callback: function($$v) {
        _vm.newEntry.code = $$v
      },
      expression: "newEntry.code"
    }
  })], 1), _vm._v(" "), _c('td', [_c('text-input', {
    on: {
      "input": _vm.addEntryWithSlug
    },
    model: {
      value: (_vm.newEntry.slug),
      callback: function($$v) {
        _vm.newEntry.slug = $$v
      },
      expression: "newEntry.slug"
    }
  })], 1), _vm._v(" "), _c('td')])], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52c86776","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/ColorManager.vue
// module id = 1986
// module chunks = 0